import Reveal from "@/components/base/Reveal";
import { timelineNodes } from "@/mocks/home";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-secondary-50 py-16 md:py-20">
      <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <span className="text-xs font-medium tracking-[0.24em] text-primary-600">
                FULL TIMELINE
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                完整时间线
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-secondary-600">
                从事件起点到最新进展，按天归档、逐个节点标注材料来源与核对结果。
                想搞清楚来龙去脉，从这里顺着往下看最省事。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                <span className="rounded-full bg-background-50 px-3 py-1 text-xs text-secondary-700">
                  共 128 个节点
                </span>
                <span className="rounded-full bg-background-50 px-3 py-1 text-xs text-secondary-700">
                  跨度 90 天
                </span>
                <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                  持续更新
                </span>
              </div>
              <a
                href="#evidence"
                className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-folder-download-line text-base" />
                获取全部原始材料
              </a>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ol className="relative space-y-4 border-l border-secondary-200 pl-6 md:pl-8">
            {timelineNodes.map((node, index) => (
              <Reveal
                key={node.day}
                as="li"
                delay={40 * index}
                className="relative"
              >
                <span className="absolute -left-[31px] top-4 flex h-3 w-3 items-center justify-center rounded-full border-2 border-secondary-50 bg-primary-500 md:-left-[39px]" />
                <div className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-heading text-sm font-bold text-primary-600">
                      {node.day}
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {node.title}
                    </h3>
                    <span className="ml-auto rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-800">
                      {node.tag}
                    </span>
                  </div>
                  <p className="mt-2.5 text-sm leading-relaxed text-secondary-600">
                    {node.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}